<template>
  <b-container class="py-2 py-md-5">
    <h1 class="text-center pricing-header">Pricing Plans</h1>
    <h2 class="text-center pricing-sub-header mb-5">Choose the best plan that fits your requirements</h2>
    <b-row class="d-flex align-items-center mb-5">
      <b-col>
        <b-card id="essential">
          <div class="px-3">
            <img src="@/assets/images/pricing/essential.svg" alt="Essential" id="essential-bldg" class="mx-auto d-block mt-2 mb-3">
            <h3 class="card-title text-center mb-4">Essential</h3>
            <h4 class="card-subtitle text-center mb-4">The basics for small businesses to run a loyalty program smoothly.</h4>
            <h5 class="price text-center mb-4">2,499/month</h5>
            <b-row class="mb-4" no-gutters>
              <b-col cols="1"><img src="@/assets/images/pricing/check.svg" class="check" alt="Check Mark"></b-col>
              <b-col class="pl-md-3">
                <p class="mb-0">Up to <strong>10,000</strong> number of registered users</p>
              </b-col>
            </b-row>
            <b-row class="mb-4" no-gutters>
              <b-col cols="1"><img src="@/assets/images/pricing/check.svg" class="check" alt="Check Mark"></b-col>
              <b-col class="pl-md-3">
                <p class="mb-0"><strong>5,000*</strong> FREE SMS per month</p>
                <p class="small mb-0 sms-notice">*Any SMS sent in excess of this volume shall be charged at Php0.60 per SMS</p>
              </b-col>
            </b-row>
            <b-button block variant="primary" class="green-btn" to="/register">Try For Free*</b-button>
            <p class="small text-center mt-2 mb-0 no-credit-card">* No credit card required.</p>
            <p class="small text-center mb-0 no-credit-card">* Free for 60 days</p>
          </div>
        </b-card>
      </b-col>
      <b-col>
        <b-card id="professional">
          <template v-slot:header>
            <h6 class="mb-0 text-center text-uppercase">Recommended</h6>
          </template>
          <div class="px-3 pb-3">
            <img src="@/assets/images/pricing/professional.svg" alt="Professional" id="professional-bldg" class="mx-auto d-block mt-2 mb-3">
            <h3 class="card-title text-center mb-4">Professional</h3>
            <h4 class="card-subtitle text-center mb-4">A must-have for growing companies and businesses that want to scale. Includes additional capabilities.</h4>
            <h5 class="price text-center mb-4">14,999/month</h5>
            <b-row class="mb-4" no-gutters>
              <b-col cols="1"><img src="@/assets/images/pricing/check.svg" class="check" alt="Check Mark"></b-col>
              <b-col class="pl-md-3">
                <p class="mb-0">Up to <strong>10,000 - 50,000</strong> number of registered users</p>
              </b-col>
            </b-row>
            <b-row class="mb-4" no-gutters>
              <b-col cols="1"><img src="@/assets/images/pricing/check.svg" class="check" alt="Check Mark"></b-col>
              <b-col class="pl-md-3">
                <p class="mb-0"><strong>10,000*</strong> FREE SMS per month</p>
                <p class="small mb-0 sms-notice">*Any SMS sent in excess of this volume shall be charged at Php0.60 per SMS</p>
              </b-col>
            </b-row>
            <b-button block variant="primary" class="yellow-btn" to="/register">Upgrade</b-button>
          </div>
        </b-card>
      </b-col>
      <b-col>
        <b-card id="enterprise">
          <div class="px-3 pb-3">
            <img src="@/assets/images/pricing/enterprise.svg" alt="Enterprise" id="enterprise-bldg" class="mx-auto d-block mt-2 mb-3">
            <h3 class="card-title text-center mb-4">Enterprise</h3>
            <h4 class="card-subtitle text-center mb-4">A must for enterprises and titans of the industries. Includes custom builds and the capacity to manage hundreds of thousands</h4>
            <h5 class="price text-center mb-4">49,999/month</h5>
            <b-row class="mb-4" no-gutters>
              <b-col cols="1"><img src="@/assets/images/pricing/check.svg" class="check" alt="Check Mark"></b-col>
              <b-col class="pl-md-3">
                <p class="mb-0">Up to <strong>50,000 - 250,000</strong> number of registered users</p>
              </b-col>
            </b-row>
            <b-row class="mb-4" no-gutters>
              <b-col cols="1"><img src="@/assets/images/pricing/check.svg" class="check" alt="Check Mark"></b-col>
              <b-col class="pl-md-3">
                <p class="mb-0"><strong>50,000*</strong> FREE SMS per month</p>
                <p class="small mb-0 sms-notice">*Any SMS sent in excess of this volume shall be charged at Php0.60 per SMS</p>
              </b-col>
            </b-row>
            <b-button block variant="primary" class="blue-btn" to="/register">Contact Sales</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <div id="features" class="pt-5">
      <b-row>
        <b-col>
          <b-table :fields="fields" :items="items" borderless>
            <template v-slot:cell(features)="data">
              {{ data.value }}
              <template v-if="data.item.description !== ''">
                <i class="ic-tooltip ml-1 d-inline-block" :id="'tooltip-' + data.index"></i>
                <b-tooltip :target="'tooltip-' + data.index" triggers="hover" placement="right">
                  {{ data.item.description }}
                </b-tooltip>
              </template>
            </template>
            <template v-slot:cell(essential)="data">
              <template v-if="data.value == 1">
                <img src="@/assets/images/pricing/table-check.svg" alt="Check">
              </template>
              <template v-else-if="data.value != 0">
                {{ data.value }}
              </template>
            </template>
            <template v-slot:cell(professional)="data">
              <template v-if="data.value == 1">
                <img src="@/assets/images/pricing/table-check.svg" alt="Check">
              </template>
              <template v-else-if="data.value != 0">
                {{ data.value }}
              </template>
            </template>
            <template v-slot:cell(enterprise)="data">
              <template v-if="data.value == 1">
                <img src="@/assets/images/pricing/table-check.svg" alt="Check">
              </template>
              <template v-else-if="data.value != 0">
                {{ data.value }}
              </template>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
export default {
  name: 'Pricing',
  data() {
    return {
      fields: [
        { key: "features", label: "Features" },
        { key: "essential", label: "Essential" },
        { key: "professional", label: "Professional" },
        { key: "enterprise", label: "Enterprise" }
      ],
      items: [
        { features: 'Channels', essential: '', professional: '', enterprise: '', description: '' }, // Heading
        { features: 'Merchant Web Portal', essential: '1', professional: '1', enterprise: '1', description: 'The platform you’ll use to manage your loyalty platform.' },
        { features: 'Customer Web Portal', essential: '1', professional: '1', enterprise: '1', description: 'The platform that customers will access to engage with your loyalty platform.' },
        { features: 'Customer App - iOS and Android', essential: '0', professional: '1', enterprise: '1', description: 'A whitelabel mobile app to engage, reward and nurture your customers.' },
        { features: 'Merchant Androi App', essential: '0', professional: '1', enterprise: '1', description: 'A mobile based app where you can manage your loyalty platform.' },
        { features: 'API Access', essential: '0', professional: '1', enterprise: '1', description: 'APIs access to ensure seamless delivery of services.' },
        { features: 'Mechanics', essential: '', professional: '', enterprise: '', description: '' }, // Heading
        { features: 'Points Conversion', essential: '1', professional: '1', enterprise: '1', description: 'Conversion of points to rewards.' },
        { features: 'Expiry of Points', essential: '1', professional: '1', enterprise: '1', description: 'The capability to put an end date to your customer’s points.' },
        { features: 'Points Transfer', essential: '0', professional: '1', enterprise: '1', description: 'The capability to allow customers to transfer points to someone else.' },
        { features: 'Achievement Unlock', essential: '0', professional: '1', enterprise: '1', description: 'The capability to create task-based milestones for your customers.' },
        { features: 'Refer a Friend', essential: '1', professional: '1', enterprise: '1', description: 'The capability to create a referral program that will increase acquisition for your business.' },
        { features: 'Rewards', essential: '', professional: '', enterprise: '', description: '' }, // Heading
        { features: 'Rewards Catalog', essential: '0', professional: '1', enterprise: '1', description: 'The capability to create a catalog containing numerous rewards your customers can redeem.' },
        { features: 'Instant Gratification', essential: '0', professional: '1', enterprise: '1', description: 'The capability to provide instant rewards for your customers to delight them.' },
        { features: 'Voucher Management', essential: '0', professional: '0', enterprise: '1', description: 'The capability to manage numerous vouchers to delight customers.' },
        { features: 'Engagement', essential: '', professional: '', enterprise: '', description: '' }, // Heading
        { features: 'SMS', essential: '1', professional: '1', enterprise: '1', description: 'The capability to send text messages to your customers to engage and communicate with them.' },
        { features: 'Email', essential: '0', professional: '1', enterprise: '1', description: 'The capability to send emails to your customers to engage and communicate with them.' },
        { features: 'Push Notification', essential: '0', professional: '1', enterprise: '1', description: 'The capability to send app notification to your customers to engage and communicate with them.' },
        { features: 'Report', essential: '', professional: '', enterprise: '', description: '' }, // Heading
        { features: 'Transaction History', essential: '1', professional: '1', enterprise: '1', description: 'The capability to generate your customer;s transaction history.' },
        { features: 'Analytics', essential: '0', professional: '1', enterprise: '1', description: 'The capability to gather data about your consumers to understand them better.' },
        { features: 'Customer Single - View', essential: '0', professional: '1', enterprise: '1', description: 'The capability to get to know your customers individually.' },
        { features: 'Top-Ups (per month)', essential: '', professional: '', enterprise: '', description: '' }, // Heading
        { features: 'E-Store', essential: '', professional: 'Php 7,500', enterprise: 'Php 5,000', description: 'The capability to create an e-commerce feature in your loyalty program.' },
        { features: 'Class Booking', essential: '', professional: 'Php 5,000', enterprise: 'Php 3,000', description: 'The capability to book classes and sessions in advance through your loyalty program.' },
        { features: 'Restaurant Reservation', essential: '', professional: 'Php 3,000', enterprise: 'Php 2,000', description: 'The capability to reserve slots for your restaurant through your loyalty program.' },
        { features: 'Whitelisting', essential: '', professional: 'Php 2,000', enterprise: 'FREE', description: 'The capability to have your very own branding in your mobile app.' },
        { features: 'Privilege Card Bundle', essential: '', professional: '', enterprise: 'FREE', description: 'The capability to integrate a privilege card to your digital loyalty program.' },
        { features: 'Support', essential: '', professional: '', enterprise: '', description: '' }, // Heading
        { features: 'Email', essential: '0', professional: '1', enterprise: '1', description: 'The capability to talk to our support team through email.' },
        { features: 'Chat (via Viber)', essential: '0', professional: '0', enterprise: '1', description: 'The capability to talk to our support team through Viber.' },
        { features: 'Phone', essential: '0', professional: '1', enterprise: '1', description: 'The capability to talk to our support team through phonecalls.' },
        { features: 'Consultation', essential: 'Bi-Annual', professional: 'Quarterly', enterprise: 'Monthly', description: '' }, // Heading
        { features: 'Live Webinar', essential: '1', professional: '1', enterprise: '1', description: 'The capability to join our webinars to get the latest on loyalty marketing techniques.' },
        { features: 'Group On-Boarding', essential: '0', professional: '1', enterprise: '1', description: 'The capability to join our group on-boarding to get to know our product and platform.' },
        { features: 'Private On-Boarding', essential: '0', professional: '0', enterprise: '1', description: 'The capability to have a private on-boarding, so we can tailor fit the tutorial according to what your brand needs.' },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./../assets/styles/views/pricing.scss";
</style>
